import React, {FunctionComponent, useMemo} from 'react';
import ServerTable, {TableHeadActionsProps} from "../../ServerTable";
import {TableColumn} from "../../../../models/Table";
import {Link} from 'react-router-dom';
import ClientService from '../../../../services/ClientService';
import { ContractLockRule } from '../../../../models/ContractLockRule';
import ContractLockRuleService from '../../../../services/ContractLockRuleService';
import ContractWarningRuleService from '../../../../services/ContractWarningRuleService';
import { ContractWarningRule } from '../../../../models/ContractWarningRule';

export default () => {
    const tableService = new ContractLockRuleService()
    const columns = useMemo<TableColumn<ContractLockRule>[]>(() => [
        {
            Header: 'Nazwa',
            accessor: ({name}) => name,
            sortBy: 'number'
        },
        {
            Header: 'Treść',
            accessor: ({message_admin}) => message_admin,
            sortBy: ''
        },
        {
            Header: 'Opcje',
            accessor: ({id}) => <Link to={`/admin/settings/lockrules/${id}`}>
                <button className="btn btn-sm btn-primary">Edytuj</button>
            </Link>,
            sortBy: ''
        },
    ], [])

    const header: FunctionComponent<TableHeadActionsProps> = ({onInput}) =>
        <div className="input-group">
            <input className="form-control" type="text" placeholder="Szukaj..." aria-label="Szukaj..."
                onChange={e => {
                    onInput({query: e.target.value})
                }}/>
            <Link to={`/admin/settings/lockrules/add`}>
                <button className="btn btn-lg btn-primary">Dodaj nowy</button>
            </Link>
        </div>

    return <ServerTable<ContractLockRule> tableService={tableService} columns={columns}>
        {{header}}
    </ServerTable>
}